import {NgModule} from '@angular/core';
import {TranslateModule, TranslatePipe} from '@ngx-translate/core';
import {IsSvgPipe} from './pipes/is-svg.pipe';
import {TagsPipe} from './pipes/tags.pipe';

@NgModule({
  declarations: [TagsPipe, IsSvgPipe],
  imports: [TranslateModule],
  exports: [TagsPipe, TranslateModule, IsSvgPipe],
  providers: [TranslatePipe],
})
export class CoreModule {}
